<template>
  <div class="nav">
    <img
      @click="toHome"
      alt="Pepper logo"
      src="@/assets/images/logo.png"
      class="logo"
    />
    <h1>Site Directory</h1>

    <div v-for="(brand, brandName) in brands" :key="brandName">
      <h3>{{ brand.name }}</h3>

      <div v-for="(device, deviceName) in brand.devices" :key="deviceName">
        <h4>Content for the device: {{ device.name }}</h4>

        <div>
          <p>Installation Instructions</p>
          <div v-for="(step, stepOrder) in device.installationInstructions" :key="`instructions-${stepOrder}`">
            <router-link :to="{
              name: 'instructions',
              params: {
                brand: brandName,
                device: deviceName,
                step: stepOrder
              },
              query: {
                mode: $route.query.mode || 'light'
              },
            }">Step {{ stepOrder }}: {{ step.title }}</router-link>
          </div>
        </div>

      </div>

      <div v-for="(category, categoryName) in brand.categories" :key="categoryName">
        <h4>Content for the category: {{ category.name }}</h4>

        <div>
          <p>Category Instructions</p>
          <div v-for="(step, stepOrder) in category.installationInstructions" :key="`instructions-${stepOrder}`">
            <router-link :to="{
              name: 'categoryInstructions',
              params: {
                brand: brandName,
                category: categoryName,
                step: stepOrder
              },
              query: {
                mode: $route.query.mode || 'light'
              },
            }">Step {{ stepOrder }}: {{ step.title }}</router-link>
          </div>
        </div>

      </div>
    </div>

    <h3>Demos</h3>

    <div>
      <router-link
        :to="{
          name:'sendHelpTutorial',
          query: {
            mode: $route.query.mode || 'light'
          },
        }">Send Help Tutorial</router-link>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Home',
  computed: {
    ...mapState(['brands']),
  },
  methods: {
    toHome() {
      this.$router.push('/');
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.logo {
  cursor: pointer;
  margin-top: 20px;
}
.nav {
  align-items: center;
  display: flex;
  flex-direction: column;
  padding: 30px;

  a {
    color: #42b983;
  }
}
h3 {
  margin: 40px 0 10px;
}
</style>
